





































import { Component, Vue } from "vue-property-decorator";
import { mapState } from "vuex";
import { changeTextColor } from "@/utils/color";

@Component({
  computed: {
    ...mapState({
      loading: "loading"
    }),
    ...mapState("Auth", {
      business: "activeBusiness"
    })
  },
  methods: {
    changeTextColor
  }
})
export default class BusinessTagCreate extends Vue {
  business!: Model;
  loading!: boolean;

  newTag = {
    name: "",
    color: "#e0e0e0"
  };

  async addNewTag() {
    await this.$store.dispatch("BusinessTag/create", {
      ...this.newTag,
      business_oid: this.business.object_id
    });

    this.$emit("completed");
  }
}
